// Safari < 15.4 drops dvh units, so a missing support check must fall back to vh.
export const viewportHeight = (percent: number): string => {
  const supportsDvh =
    typeof CSS !== 'undefined' &&
    typeof CSS.supports === 'function' &&
    CSS.supports('height', '1dvh');
  return `${percent}${supportsDvh ? 'dvh' : 'vh'}`;
};
